import * as React from "react";

export const SvgCheck = (props) => (
	<svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="m16.002 6-8.25 8-3.75-3.636"
			stroke={props.color ?? "#A8A8A8"}
			strokeWidth={1.863}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
